import Http from '../../../services/http'
import { dataSources } from '../../../utils/data-sources'
import { getFraudHeaders } from '../../../utils/get-fraud-headers'

/**
* This function is used at login to sync obligations
* @param sessionStore the sessionStore instance
* @param taxRegistrationStore the taxRegistrationStore instance
* @returns Promise
*/
export function syncObligationsData (sessionStore, taxRegistrationStore) {
  const http = Http.getInstance(sessionStore)
  const ds = dataSources()

  return getFraudHeaders(sessionStore)
    .then((fraudHeaders) => {
      const syncObligations = []
      for (let i = 0; i < taxRegistrationStore.taxRegistrationList.length; i++) {
        const taxRegistration = taxRegistrationStore.taxRegistrationList[i]
        syncObligations.push(http.getData(`${ds.taxRegistrations}/${taxRegistration.id}/obligation/sync`, {
          'headers': fraudHeaders
        }))
      }
      return syncObligations
    })
    .then((syncObligations) => {
      return Promise.all(syncObligations)
    })
    .then((response) => {
      const authFailed = response.filter(item => {
        if (item.status === 500 && item.data.status === 'error' && item.data.message.match(/Authorisation with HMRC has failed/gi)) {
          return true
        }
        return undefined
      })
      return (authFailed.length === 0)
    })
    .catch((err) => {
      // Ignore any errors for obligations when syncing here
      console.error(err)
      return true
    })
}
